import { render, staticRenderFns } from "./MiniBitacora.vue?vue&type=template&id=98d4c156&"
import script from "./MiniBitacora.vue?vue&type=script&lang=js&"
export * from "./MiniBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports